import { render, staticRenderFns } from "./AdminChangelogInnerTableRow.vue?vue&type=template&id=d2db66d6&"
import script from "./AdminChangelogInnerTableRow.vue?vue&type=script&lang=ts&"
export * from "./AdminChangelogInnerTableRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports